import React, { useState } from 'react';
import styled from 'styled-components';
import { Box, InfoAlert, Link } from '@99designs/emu';
import { FormattedReactMessage } from '@99designs/frontend-components/i18n';

export interface PreviewAlertProps {
    downloadUrl: string;
    positionBottom?: boolean;
}

const PreviewAlertBody = styled(Box)`
    z-index: 1;
`;

function PreviewAlert({ downloadUrl, positionBottom }: PreviewAlertProps) {
    const [dismissed, setDismissed] = useState(false);
    return (
        <PreviewAlertBody
            position={'absolute'}
            width={'100%'}
            paddingTop={'none'}
            paddingRight={['1bu', '2bu']}
            paddingBottom={'2bu'}
            paddingLeft={['1bu', '2bu']}
            bottom={positionBottom ? 'none' : undefined}
        >
            <InfoAlert dismissed={dismissed} onDismiss={() => setDismissed(true)}>
                <FormattedReactMessage
                    message={__(
                        'This is a preview. To see the complete file, <Link>download the original</Link>.'
                    )}
                    replacements={{
                        Link: <Link href={downloadUrl} color="white" />,
                    }}
                />
            </InfoAlert>
        </PreviewAlertBody>
    );
}

export default PreviewAlert;
